import { makeStyles } from "@material-ui/core";

const styles = makeStyles(({ spacing }) => ({
  container: {
    position: "relative",
    width: 240,
    height: 130,
  },
  image: (props?: { isSolidCard?: boolean }) => ({
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    borderRadius: props?.isSolidCard ? spacing(1, 1, 0, 0) : spacing(1),
    objectFit: "fill",
  }),
  detailsView: {
    backgroundColor: "rgba(0, 0, 0, 0.50)",
    padding: spacing(0.5, 1),
    borderRadius: spacing(1),
    width: "fit-content",
  },
  icon: {
    width: spacing(1.5),
    height: spacing(1.5),
    marginRight: spacing(0.5),
    color: "white",
  },
  detailsText: {
    color: "white",
    fontSize: 10,
    fontWeight: 500,
    lineHeight: 1.2,
    letterSpacing: "1px",
    textTransform: "uppercase",
  },
  dateContainer: {
    minWidth: 175,
  },
}));

export default styles;
